export default "__VITE_ASSET__rW99p3yu__"